import { ElementsPackTypes } from 'modules/Editor/components/WidgetMenu/SideMenu/ElementsMenu/ElementsMenu.types';
import { ReadOnlyRenderType } from 'widgets/Widget.types';
import { ReadOnlyWidgetBase, TransparentImg, WidgetBase, WidgetBaseProp, WidgetToolbar, useWidget } from 'widgets/sdk';

import { useEditor } from '../sdk/useEditor';
import { LottiePlayer } from './LottiePlayer';
import { LottieWidgetData } from './LottieWidget.types';
import { LottieWidgetToolbar } from './LottieWidgetToolbar';

export const LottieWidget = () => {
  const { openReplaceElementWidgetMenu } = useEditor();
  const onDoubleClick = () => openReplaceElementWidgetMenu(ElementsPackTypes.GifsReplace);

  return (
    <WidgetBase onDoubleClick={onDoubleClick}>
      <WidgetToolbar>
        <LottieWidgetToolbar />
      </WidgetToolbar>
      <WidgetRender />
    </WidgetBase>
  );
};

const WidgetRender = () => {
  const { url, widthPx, heightPx, renderType } = useWidget<LottieWidgetData>();

  const isExportRender = renderType === ReadOnlyRenderType.ExportStructureTreeList;
  const isThumbnailReadOnly = renderType === ReadOnlyRenderType.ThumbnailReadOnly;

  if (isExportRender || isThumbnailReadOnly) {
    return <LottiePlayer src={url} width={widthPx} renderer='canvas' height={heightPx} autoplay={false} />;
  }

  return <LottiePlayer src={url} width='100%' height='100%' style={{ position: 'absolute' }} />;
};

export const ReadOnlyLottieWidget = ({ includeAltTextImg }: WidgetBaseProp) => {
  return (
    <ReadOnlyWidgetBase>
      <WidgetRender />
      {includeAltTextImg && <TransparentImg />}
    </ReadOnlyWidgetBase>
  );
};
